<template>
  <a-row type="flex" justify="center">
    <div v-for="(item, index) in employee.investment_partner.slice(0,4)"
         class="team_employee" :key="index">
      <img :src="item.picture" @click="showmodal(index)">
    </div>
  </a-row>
  <a-row type="flex" justify="center">
    <a-col :span="5" class="team_employee">
      <img :src="'http://sig-china.com/media/employee/joanren.jpg'" @click="showmodal(4)">
      <!--employee.investment_partner[n].picture 读取有误-->
    </a-col>
    <a-col :span="10" style="background-color: #3047d3;width: 41.7vw;
     position: relative">
      <div style="margin: 0 6vw; text-align: left;position: absolute;top: 50%;
       -webkit-transform:translateY(-50%);transform:translateY(-50%);">
        <p style="font-size: 26px">Our Team</p>
        <p style="font-size: 16px">Based on years of in-depth assessments of numerous companies in different industries,
          we are willing to
          provide our portfolio companies with great assistance to accelerate post-investment performance. SIG is
          dedicated to helping our entrepreneurs build successful companies by providing them with capital, guidance,
          network and the best resources available.</p>
        <a-popover placement="top">
          <template #content>
            <img src="../../../assets/qr.gif" style="width: 100px;height: 100px">
            <p style="color: black; font-size: 10px; margin-bottom: 0">微信扫二维码</p>
          </template>
          <WechatFilled style="color: white; font-size: 2vh; padding-right: 1vw"/>
        </a-popover>
        <WeiboCircleFilled style="color: white; font-size: 2vh;" @click="shareweibo"/>
      </div>
    </a-col>
    <a-col :span="5" class="team_employee">
      <img :src="'https://sig-china.com/media/employee/download-7.jpg'" @click="showmodal(5)">
    </a-col>
  </a-row>
  <div style="padding: 0 8.3vw">
    <a-row type="flex">
      <div v-for="(item, index) in employee.investment_partner.slice(6,)"
           class="team_employee" :key="index">
        <img :src="item.picture" @click="showmodal(index+6)">
      </div>
    </a-row>
  </div>

  <a-modal v-model:visible="modal.visible" @click="close" width="60vw"
           :centered="true" :footer="null">
    <div style="text-align: center;height: 60vh">
      <p class="detail_title">{{ modal.name }}</p>
      <img src="../../../assets/image/line.png" style="vertical-align: center;width: 120px">
      <p class="detail_page">{{ modal.introduction }}</p>
    </div>
  </a-modal>

</template>

<script>
import {onMounted, reactive} from 'vue'
import axios from "axios";
import {WeiboCircleFilled, WechatFilled,} from '@ant-design/icons-vue'

export default {
  name: 'Team_partner_en',
  components: {WeiboCircleFilled, WechatFilled},
  setup() {
    let employee = reactive({
      investment_partner: [],
    })
    let modal = reactive({
          visible: false,
          name: '',
          introduction: '',
        }
    )
    const shareweibo = () => {
      let title = "海纳百川 投资团队"
      let url = encodeURIComponent(window.location.href);
      let sinaurl = 'https://service.weibo.com/share/share.php?url=' + url + '&type=button&language=zh_cn&title=' + title
          + '&searchPic=true&style=number#_loginLayer_1496300586101';
      window.open(sinaurl);
    }
    const showmodal = (index) => {
      modal.visible = true;
      modal.name = employee.investment_partner[index].name_en
      modal.introduction = employee.investment_partner[index].introduction_en
    }
    const close = (e) => {
      console.log(e)
      modal.visible = false
    }

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/partner')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              employee.investment_partner.push(res.data[i])
            }
            employee.investment_partner.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.investment_partner.length; i++) {
              employee.investment_partner[i]['picture'] = 'https://sig-china.com' + employee.investment_partner[i]['picture']
            }
          })
    })

    return {employee, modal, showmodal, close, shareweibo}
  }
}
</script>

<style scoped>
.team_employee {
  width: 20.8vw;
  height: auto;
  align-items: center;
  justify-content: center;
}

img {
  width: auto;
  height: auto;
  max-width: 20.8vw;

}

.detail_page {
  color: black;
  white-space: pre-wrap;
  margin: 5vh 10vh;
  font-size: 16px;
  text-align: left;
    max-height: 40vh;
  overflow-x: hidden;
}

.detail_title {
  margin-top: 2vh;
  color: black;
  font-size: 42px;
  text-align: center;
  margin-bottom: 1vh;
}


</style>
